import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as LoadingIcon } from '../../../../svgs/spinner.svg';
import styles from './profileIntro.module.css';

const ProfileIntro = ({ url, name, title, initials, isFetching }) => (
  <div className={styles.container}>
    <div className={styles.nameContainer}>
      {url.length > 0 ? (
        <img src={url} className={styles.img} alt="doctor" />
      ) : (
        <div className={styles.noPic}>
          <div className={styles.blueCircle}>
            {isFetching ? (
              <LoadingIcon className={styles.spinner} />
            ) : (
              <div className={styles.initials}>{initials}</div>
            )}
          </div>
        </div>
      )}
      <span className={styles.name}>{name}</span>
      <span className={styles.drType}>{title}</span>
    </div>
  </div>
);

ProfileIntro.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  initials: PropTypes.string,
  isFetching: PropTypes.bool.isRequired,
};

export default ProfileIntro;
